import { RefreshCw } from 'lucide-react';

const Loader = ({ text = 'Hold on! Fetching the data' }: { text?: string }) => {
  return (
    <div className="flex flex-col flex-1 justify-center items-center p-20 text-[#621C43]">
      <RefreshCw className="size-20 mb-6 animate-spin" />
      <p className="text-2xl text-center">{text}</p>
    </div>
  );
};

export default Loader;
